/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import type { IAPI } from '../apiResponse';
import { createApiResponseSchema } from '../apiResponse';
import { ticketSchema } from './ticket-schema';

export const ticketResponseSchema = createApiResponseSchema(ticketSchema) as z.ZodSchema<
  IAPI<z.infer<typeof ticketSchema>>
>;

export type ITicketResponse = IAPI<z.infer<typeof ticketSchema>>;
